export default function interval(intervalObj) {
  let str = ''
  if (intervalObj?.days) str += `${intervalObj?.days}D`
  if (intervalObj?.hours) str += ` ${intervalObj?.hours}hr`
  if (intervalObj?.minutes) str += ` ${intervalObj?.minutes}min`

  return str.trimStart() || '-'
}
